import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=10e74779&scoped=true&"
import script from "./smsTemplate.vue?vue&type=script&lang=js&"
export * from "./smsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=10e74779&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e74779",
  null
  
)

export default component.exports